import { Component, OnInit, ViewChild, ElementRef, Input } from "@angular/core";
import { Library } from "src/app/models/library";
import { Media } from "src/app/models/media";
import { styles } from "../printing-styles";
import { ActivatedRoute, Router } from "@angular/router";
import { ApplicationPool } from "src/app/services/application.pool";
import { ActionService } from "src/app/services/action.service";
import { EmptyPageService } from "src/app/services/empty-page.service";

@Component({
  selector: "app-print-media-signatures",
  templateUrl: "./print-media-signatures.component.html",
  styles
})
export class PrintMediaSignaturesComponent implements OnInit {
  @ViewChild("content") private contentRef: ElementRef;

  private ids: number[] = [];
  private print: boolean = true;
  private alreadySetPresent = false;

  public blankBarcodes: number[] = [];

  private get Library(): Library {
    return this.dataPool.Library;
  }

  public get Medias(): Media[] {
    if (this.dataPool.Medias) {
      const medias = this.dataPool.Medias.filter(
        (m) => this.ids.filter((id) => m.id == id).length > 0
      );
      if (!this.alreadySetPresent) {
        this.alreadySetPresent = true;
        medias.forEach((m) => {
          this.dataService.setMediaPresent(m);
        });
      }
      if (this.print) {
        this.print = false;
        const t = this;
        setTimeout(() => {
          this.emptyPageService.render(
            `<html moznomarginboxes mozdisallowselectionprint class="${this.Library.configuration.optimizeLabelsForThermalTransfer ? "thermal-transfer-optimized" : ""}"><head><style>${styles[0]} @page { margin-top: ${t.MarginTop}; margin-left: ${t.MarginLeft}; margin-right: 0px; margin-bottom:0px;} media-barcode, media-signature {page-break-inside: avoid;width: ${t.Width}; height: ${t.Height};}
            div.signature {
             text-align: center;
             display: table!important;
             height:100%;
             font-size: 25px !important;
             line-height: 30px; 
             float:left;
           }
           div.signature>div {
             display:table-cell;
             vertical-align:middle;
           }
           div.signature * {
             font-size: 14px !important;
             line-height: 20px;
           }
           div.signature .id {font-size:90%}
           body {margin:0px;}
           .thermal-transfer-optimized * {font-family: "Arial" !important; font-weight: 600;} 
           .thermal-transfer-optimized .sign {font-weight: 800;}
           </style></head><body>${t.contentRef.nativeElement.innerHTML}</body></html>`
          );
          setTimeout(() => {
            this.emptyPageService.print();
          }, 100);
          this.router.navigate(["/media/barcode"]);
        }, 50);
      }
      return medias;
    }
  }

  private get Width(): string {
    if (this.Library) {
      return `${this.Library.configuration.signatureDimensions.width}cm`;
    }
  }

  private get Height(): string {
    if (this.Library) {
      return `${this.Library.configuration.signatureDimensions.height * 1}cm`;
    }
  }

  private get MarginLeft(): string {
    if (this.Library) {
      return `${this.Library.configuration.signatureDimensions.sheetMarginLeft}cm`;
    }
  }

  private get MarginTop(): string {
    if (this.Library) {
      return `${this.Library.configuration.signatureDimensions.sheetMarginTop}cm`;
    }
  }

  constructor(
    private route: ActivatedRoute,
    private dataPool: ApplicationPool,
    private dataService: ActionService,
    private router: Router,
    private emptyPageService: EmptyPageService
  ) {
    this.route.params.subscribe((params: any[]) => {
      this.ids = JSON.parse(params["val"]).media;
      const blank: any = JSON.parse(params["val"]).blankBarcodes;
      if (blank) {
        let blankBarcodesCount = +blank;
        while (blankBarcodesCount-- > 0) {
          this.blankBarcodes.push(0);
        }
      }
    });
  }

  ngOnInit(): void {}

  get signatureColorRectangle() {
    return (
      this.dataPool.Library.configuration?.printSignatureRectangle || false
    );
  }
}
